import React, { useEffect, useState } from "react";
import { Box, Text } from "grommet";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { LinkPrevious } from "grommet-icons";
import { useParams } from "react-router-dom";
// import { DedicatedLearningButton } from "../../components/Buttons/DedicatedLearning";
// import UserAssessmentDetails from "../../components/Dashboard/UserAssessmentsDetails";
import { UserAssessmentDetailsManager } from "../../components/ManagerPortal/UserAssessmentsDetailsManager";
const ManagerAssessmentQuizResultsPage = () => {
  const { assessment_id } = useParams();
  const location = useLocation();
  const name = location.state?.name || {};
  const due_by = location.state?.due_by || {};
  console.log("Assessment:", name, due_by);
  const navigate = useNavigate();

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />

        <Box
          align="center"
          pad={{ horizontal: "medium", vertical: "medium" }}
          margin={{ horizontal: "small", vertical: "medium" }}
        >
          <Box alignSelf="start">
            <LinkPrevious
              onClick={() => {
                navigate(-1);
              }}
              size="large"
              color="brand"
            />
          </Box>
          <Box alignSelf="center" alignContent="center" align="center">
            <Text size="large" weight="bold" margin={{ bottom: "small" }}>
              Skills summary report - {name}<br/>
            </Text>
            <Text size="medium" margin={{ bottom: "small" }}>
              Due by: {new Date(due_by).toLocaleDateString()}, {new Date(due_by).toLocaleTimeString()}
            </Text>
            <Text size="medium" margin={{ bottom: "medium" }}>
              Here are the results for the assessment
            </Text>
          </Box>

          <Box width="100%" pad={{ horizontal: "medium" }} border={{ color: "brand", size: "small" }}>
              <Box
                pad="medium"
                direction="column"
                justify="between"
                align="center"
              >
                <UserAssessmentDetailsManager assessment_id={assessment_id} />
              </Box>
              <Box
                direction="row"
                pad="medium"
                align="center" // Align the items to the center
                alignContent="center" // Align the content to the center
                alignSelf="center" // Align the box to the center
              >
            </Box>
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default ManagerAssessmentQuizResultsPage;
